import { PmiButton } from 'shell/components/shared/button';
import { Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { memo, ReactElement } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { alphanumericRegex, nameSurnameMoreCharactersAccentsRegex } from 'shell/constants/regex';
import PmiTextField from 'shell/components/shared/text-field';
import { noop } from 'shell/utils/noop';

const validationSchema = yup.object({
  type: yup
    .string()
    .nullable()
    .matches(alphanumericRegex, 'Il campo è alfanumerico')
    .required('Campo obbligatorio'),
  description: yup
    .string()
    .nullable()
    .matches(nameSurnameMoreCharactersAccentsRegex, 'Il campo è alfanumerico')
    .required('Campo obbligatorio'),
});

export interface FormRegisterVM {
  type?: string;
  description?: string;
}

interface FormRegisterProps {
  disabled?: boolean;
  title: string;
  onCancel: () => void;
  initialValues?: FormRegisterVM;
  onSubmit?: (values: FormRegisterVM) => void;
  isEdit?: boolean;
}

const FormRegisterComponent = ({
  disabled,
  title,
  onCancel,
  initialValues,
  isEdit,
  onSubmit,
}: FormRegisterProps): ReactElement => {
  const form = useFormik<FormRegisterVM>({
    initialValues: initialValues || {
      type: undefined,
      description: undefined,
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit || noop,
    enableReinitialize: true,
  });

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={form.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2" color="secondary">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3}>
                <PmiTextField
                  aria-label="Tipo registro"
                  label="Tipo registro *"
                  id="type"
                  name="type"
                  fullWidth
                  type="text"
                  variant="outlined"
                  value={form.values.type || ''}
                  onChange={form.handleChange}
                  inputProps={{
                    maxLength: '8',
                  }}
                  disabled={disabled || isEdit}
                  error={form.touched.type && Boolean(form.errors.type)}
                  helperText={form.errors.type}
                />
              </Grid>
              <Grid item xs={12} md={9}>
                <PmiTextField
                  aria-label="Descrizione registro"
                  label="Descrizione registro *"
                  id="description"
                  name="description"
                  fullWidth
                  type="text"
                  variant="outlined"
                  value={form.values.description || ''}
                  onChange={form.handleChange}
                  inputProps={{
                    maxLength: '50',
                  }}
                  disabled={disabled}
                  error={form.touched.description && Boolean(form.errors.description)}
                  helperText={form.errors.description}
                />
              </Grid>
            </Grid>
          </div>
        </CardContent>
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel();
            }}
          >
            Annulla
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

FormRegisterComponent.displayName = 'Research Register Page component';

const FormRegister = memo(FormRegisterComponent);

export default FormRegister;
